import { render, staticRenderFns } from "./面试题10.01_合并排序的数组.md?vue&type=template&id=60ca7147&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports